import { useTranslation } from 'react-i18next'
import { Flame } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StreakBadgeProps {
  streak: number
  size?: 'sm' | 'md'
  className?: string
}

export function StreakBadge({ streak, size = 'sm', className }: StreakBadgeProps) {
  const { t } = useTranslation()

  if (streak <= 0) return null

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full font-semibold',
        size === 'sm' && 'px-1.5 py-0.5 text-[10px]',
        size === 'md' && 'px-2 py-1 text-xs',
        streak >= 8 ? 'tag-coral' : streak >= 4 ? 'tag-chartreuse' : 'tag-lilac',
        className,
      )}
      title={t('gamification.streakWeeks', '{{count}} week streak', { count: streak })}
    >
      <Flame
        className={cn(
          size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5',
          streak >= 8
            ? 'text-coral'
            : streak >= 4
              ? 'text-chartreuse-foreground dark:text-chartreuse'
              : 'text-lilac-foreground dark:text-lilac',
        )}
      />
      {streak}
    </span>
  )
}
